import { Input, Switch, Form, AutoComplete } from 'antd';
import Typography from './Typography';
import { COLORS } from '../constants/Colors';
import MyInput from './Input';
import MyAutoComplete from './AutoComplete';
import { useRef, useState } from 'react';
import GetProfile from './VariableStore';
import { instance } from './AxiosClient';
import _, { debounce } from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';
const { Option } = AutoComplete;

const CustomerAddressForm = (props) => {
  const {
    isEdit,
    customerData,
    isSaveAddr,
    form,
    handleSearchLocation,
    addressEditData,
    selectArea,
    setSelectArea,
    isOpen,
    setIsTemp,
    isTemp,
    isSelect,
    setIsSelect,
    handleChange,
    options
  } = props;
  const intl = useIntl();


  const validateCustomRule = (_, value) => {
    if (isSelect === true ) {
      return Promise.resolve(); // Field is valid
    }
    else {
      return Promise.reject('Please Select Address'); // Field is invalid
    }

  };

  return (
    <div className='d-flex flex-column py-4 m-2'>
      <Form form={form}>
        <Form.Item
          name='addressname'
          rules={[
            {
              required: true,
              message: <FormattedMessage id='validatorAddressName' defaultMessage='Please Enter Address Name' />,
            },
          ]}
        >
          <MyInput
            isRequired
            label={<FormattedMessage id='labelAddressName' defaultMessage='Address Name' />}
            description={intl.formatMessage({ id: 'textSubAddress1', defaultMessage: '(e.g. Home, Office)' })}
            placeHolder={intl.formatMessage({ id: 'placeholderAddressName', defaultMessage: 'Enter Address Name' })}
            className='w-100'
          />
        </Form.Item>
        <Form.Item
          name='address'
          rules={[
            {
              required: true,
              message: <FormattedMessage id='validatorAddress' defaultMessage='Please Enter Address' />,
            },
          ]}
        >
          <MyInput
            isRequired
            label={<FormattedMessage id='labelAddress' defaultMessage='Address' />}
            description={intl.formatMessage({ id: 'textSubAddress2', defaultMessage: '(e.g. House Number, Buliding)' })}
            placeHolder={intl.formatMessage({ id: 'placeholderAddress', defaultMessage: 'Enter Address' })}
            className='w-100'
          />
        </Form.Item>
        <Form.Item
          name='fulladdress'
          rules={[
            {
              required: true,
              message: <FormattedMessage id='validatorAddress' defaultMessage='Please Select Address' />,
              validator: validateCustomRule
            },
          ]}
        >
          <MyAutoComplete
            isRequired
            label={<FormattedMessage id='labelFullAddress' defaultMessage='Sub-District,District,Province, Postal Code' />}
            placeholder={intl.formatMessage({ id: 'placeholderFullAddress', defaultMessage: 'Enter Address' })}
            className='w-100'
            onSearch={handleChange}
            onSelect={handleSearchLocation}
            Option={
              options &&
              _.map(options, (item, index) => (
                <Option key={_.get(item, 'subDistrictid')} value={_.get(item, 'addressName')}>
                  {_.get(item, 'addressName')}
                </Option>
              ))
            }
          />
        </Form.Item>
      </Form>
      {/* {isSaveAddr && (
        <div className='pt-4 mt-2 d-flex flex-row justify-content-between align-items-center'>
          <div className='d-flex flex-column'>
            <Typography isBold color={COLORS.Primary} className='pb-2'>
              <FormattedMessage id='labelSaveAddress' defaultMessage='Save to Address Book' />
            </Typography>
            <Typography color={COLORS.DarkGray} size='12px'>
              <FormattedMessage id='EnableAddress' defaultMessage='Enable this to save to address book' />
            </Typography>
          </div>
          <div>
            <Switch
              defaultChecked
              checked={isTemp}
              onChange={(e) => {
                setIsTemp(e);
              }}
            />
          </div>
        </div>
      )} */}
    </div>
  );
};

export default CustomerAddressForm;
